import dynamic from "next/dynamic"

export default function Icon({ icon, className }) {
  let Icon = () => null

  switch (icon) {
    case "heart-handshake":
      Icon = dynamic(() => import("public/assets/icons/heart-handshake.svg"))
      break
    case "service-shield":
      Icon = dynamic(() => import("public/assets/icons/service-shield.svg"))
      break
    case "team":
      Icon = dynamic(() => import("public/assets/icons/team.svg"))
      break
    case "heart-atom":
      Icon = dynamic(() => import("public/assets/icons/heart-atom.svg"))
      break
    case "thumbs-up":
      Icon = dynamic(() => import("public/assets/icons/thumbs-up.svg"))
      break
    case "helping-hands":
      Icon = dynamic(() => import("public/assets/icons/helping-hands.svg"))
      break
    case "fist":
      Icon = dynamic(() => import("public/assets/icons/fist.svg"))
      break
    case "quality-ribbon":
      Icon = dynamic(() => import("public/assets/icons/quality-ribbon.svg"))
      break
    case "arrow-chart":
      Icon = dynamic(() => import("public/assets/icons/arrow-chart.svg"))
      break
    case "handshake":
      Icon = dynamic(() => import("public/assets/icons/handshake.svg"))
      break
    case "scales":
      Icon = dynamic(() => import("public/assets/icons/scales.svg"))
      break
    case "gavel":
      Icon = dynamic(() => import("public/assets/icons/gavel.svg"))
      break
    case "dollar-with-checkmark":
      Icon = dynamic(() => import("public/assets/icons/dollar-with-checkmark.svg"))
      break
    case "handshake-no-sleeve":
      Icon = dynamic(() => import("public/assets/icons/handshake-no-sleeve.svg"))
      break
    case "phone-message":
      Icon = dynamic(() => import("public/assets/icons/phone-message.svg"))
      break
    case "ribbon":
      Icon = dynamic(() => import("public/assets/icons/ribbon.svg"))
      break
    case "scale-book":
      Icon = dynamic(() => import("public/assets/icons/scale-book.svg"))
      break
    case "court-house":
      Icon = dynamic(() => import("public/assets/icons/court-house.svg"))
      break
    case "punch-list":
      Icon = dynamic(() => import("public/assets/icons/punch-list.svg"))
      break
    case "checkmark-in-badge":
      Icon = dynamic(() => import("public/assets/icons/checkmark-in-badge.svg"))
      break
    case "files":
      Icon = dynamic(() => import("public/assets/icons/files.svg"))
      break
    case "hand-holding-globe":
      Icon = dynamic(() => import("public/assets/icons/hand-holding-globe.svg"))
      break
    case "hand-on-book":
      Icon = dynamic(() => import("public/assets/icons/hand-on-book.svg"))
      break
    case "people-with-heart":
      Icon = dynamic(() => import("public/assets/icons/people-with-heart.svg"))
      break
    default:
      console.error("An invalid value was provided to the IconList component's icon property")
  }

  return <Icon className={className} />
}
